import React from "react";
import OrganizationContext from "../context/OrganizationContext";

const useOrganizationContext = () => React.useContext(OrganizationContext);

export default useOrganizationContext;
